import { createSelector } from "@reduxjs/toolkit";
import { buildCeilingGridPixPathsFromLines } from "../buildCeilingGridPixPathsFromLines";
import { IPixPath } from "@multiconsult-group/multiplacer-ui";
import { selectHttpMcbimSpacesResult } from "../McBim/httpMcBimSelectors";

export const selectCeilingGridPixPaths = createSelector(
  [selectHttpMcbimSpacesResult],
  (spaces): IPixPath[] => buildCeilingGridPixPathsFromLines(spaces)
);

